// Copied from Ascend
import { Box, TabPanelsProps } from "@chakra-ui/react";

export interface RouteTabPanelsProps extends TabPanelsProps {}

export const RouteTabPanels = ({
  children,
  ...restProps
}: RouteTabPanelsProps) => {
  return <Box {...restProps}>{children}</Box>;
};
